import { render, staticRenderFns } from "./SucursalListCard.vue?vue&type=template&id=0519a152&scoped=true&"
import script from "./SucursalListCard.vue?vue&type=script&lang=js&"
export * from "./SucursalListCard.vue?vue&type=script&lang=js&"
import style0 from "./SucursalListCard.vue?vue&type=style&index=0&id=0519a152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0519a152",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VFadeTransition,VIcon,VProgressCircular,VSpacer})
